import dayjs from 'dayjs';
import { DEFAULT_LOCALE_CODE } from '../../const';

export const LearningObjectUtil = {

    getId( learningObjectData ) {
        return learningObjectData?.node?.id || '';
    },

    getFormat( learningObjectData ) {
        return ( learningObjectData?.node?.format || 'scorm' ).toLowerCase();
    },

    getName( learningObjectData, localeCode = DEFAULT_LOCALE_CODE ) {
        if ( !localeCode ) {
            localeCode = DEFAULT_LOCALE_CODE;
        }

        const locales = learningObjectData?.node?.locales ? learningObjectData.node.locales : [];
        const translatedName = locales.find( ( data ) => ( data?.locale == localeCode ) )?.name;
        return translatedName || '';
    },

    getDescription( learningObjectData, localeCode = DEFAULT_LOCALE_CODE ) {
        if ( !localeCode ) {
            localeCode = DEFAULT_LOCALE_CODE;
        }

        const locales = learningObjectData?.node?.locales ? learningObjectData.node.locales : [];
        const translatedDescription = locales.find( ( data ) => ( data?.locale == localeCode ) )?.description;
        return translatedDescription;
    },

    getDateOfCreation( learningObjectData ) {
        const time = learningObjectData?.node?.createdAt;
        if ( time !== undefined ) {
            // Convert Unix date stamp from seconds to milliseconds.
            return ( time * 1000 );
        } else {
            return undefined;
        }
    },

    getDateOfLastUpdate( learningObjectData ) {
        const time = learningObjectData?.node?.updatedAt;
        if ( time !== undefined ) {
            // Convert Unix date stamp from seconds to milliseconds.
            return ( time * 1000 );
        } else {
            return undefined;
        }
    },

    getTags( learningObjectData ) {
        return learningObjectData?.node?.tags;
    },

    getUsedByCourses( learningObjectData ) {
        return learningObjectData?.node?.usedByCourses || [];
    },

    getDuration( learningObjectData ) {
        const d = learningObjectData?.node?.duration;
        return d == 0 ? 1 : d;
    },

    getExpireAt( learningObjectData ) {
        const expireAt = dayjs( learningObjectData?.node?.expireAt );
        return expireAt.isValid() ? expireAt : null;
    },

    getAssets( learningObjectData ) {
        return learningObjectData?.node?.assets?.edges.map( i => (
            {
                isDefault: i.isDefault,
                id: i.node.id,
                name: i.node.name,
                url: i.node.url,
                mimetype: i.node.mimetype,
                locales: i.node.locales, 
            } ) );
    },

    getScormAssets( learningObjectData ) {
        if ( learningObjectData?.node?.format?.toLowerCase() !== 'scorm' ) {
            return [];
        }
        
        return learningObjectData?.node?.assets?.edges.map( i => (
            {
                isDefault: i.isDefault,
                id: i.node.id,
                name: i.node.name,
                url: i.node.url,
                mimetype: i.node.mimetype,
                locales: i.node.locales, 
            } ) );
    },

    getFileAssets( learningObjectData ) {
        if ( learningObjectData?.node?.format?.toLowerCase() !== 'file' ) {
            return [];
        }
        
        return learningObjectData?.node?.assets?.edges.map( i => (
            {
                isDefault: i.isDefault,
                id: i.node.id,
                name: i.node.name,
                url: i.node.url,
                mimetype: i.node.mimetype,
                lxpFileId: i.node.lxpFileId,
                locales: i.node.locales, 
            } ) );
    },
    
    getURLAssets( learningObjectData ) {
        if ( learningObjectData?.node?.format?.toLowerCase() !== 'url' ) {
            return [];
        }
        
        return learningObjectData?.node?.assets?.edges.map( i => (
            {
                isDefault: i.isDefault,
                id: i.node.id,
                name: i.node.name,
                url: i.node.url,
                mimetype: i.node.mimetype,
                locales: i.node.locales, 
            } ) );
    },

    getProxyURLAssets( learningObjectData ) {
        if ( learningObjectData?.node?.format?.toLowerCase() !== 'proxy' ) {
            return [];
        }
        
        return learningObjectData?.node?.assets?.edges.map( i => (
            {
                isDefault: i.isDefault,
                id: i.node.id,
                name: i.node.name, 
                mimetype: i.node.mimetype,
                locales: i.node.locales, 
            } ) );
    },
    
    getLocales( learningObjectData ) {
        return [ ...( learningObjectData?.node?.locales ?? [] ), ...( learningObjectData?.node?.metadata?.nonCMXLocales ?? [] ) ]
            .map( loc => ( { locale: loc.locale, name: loc.name, description: loc.description } ) );
    },
 
    getCourseCount( learningObjectData ) {
        return learningObjectData?.node?.courseCount;
    },

    getMetadata( learningObjectData ) {
        return learningObjectData?.node?.metadata;
    }
};
